const Meta = (props) => <meta {...props} />

export default Meta
